import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {BoosterService} from "../../services/booster.service";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-booster-plugin-update',
    templateUrl: './update-plugin.component.html',
    styleUrls: ['./update-plugin.component.scss'],
    standalone: false
})
export class UpdateBoosterPluginComponent implements OnInit {
  @Input() companyName: string;
  @Input() websiteId: number;
  @Input() websiteConnectedFrom: string;
  @Input() adminPluginsUrl: string;
  @Input() currentVersion: string;

  constructor(
    private _activeModal: DbActiveModal,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _boosterService: BoosterService
  ) {}

  ngOnInit() {
    this.resize([254, 700]);
  }

  public resize(size: [number, number]): void {
    this._activeModal.resize(...size);
  }

  public close(): void {
    this._activeModal.close();
  }

  public confirm(): void {
    this._activeModal.close();
  }
}
